<template>
  <div class="products">
    
    <div class="container" v-loading="tableLoadingVisible">
      <h1>{{ $t("feedback.page_title") }}</h1>

        <div v-if="errorFromServer">
            Feedbak already completed or other error ocured !
        </div>
        <el-form v-else :label-position="'top'" :inline="false" :rules="rules" label-width="100%" :model='newFeedback'  ref='my-form' @submit.prevent="save" >
            <el-card>
                <el-row :gutter="15">
                    <el-col :span="24">
                        <p><strong>Order Date: {{order.RequestDate}}</strong></p>
                        <p>
                            <el-tag style='min-width: 250px'>Buyer: {{buyer.Name}} ( {{buyer_factory.ShortCode}} )</el-tag> 
                            <el-tag style='min-width: 250px; margin-left: 15px;' type='success'>Seller: {{seller.Name}} ( {{seller_factory.ShortCode}} )</el-tag> 
                        </p>
                        <p>
                            <el-tag style='min-width: 250px'>Quantity: {{order.Quantity}}</el-tag> 
                            <el-tag style='min-width: 250px;margin-left: 15px;' type='success'>Product: {{product.Name}} ( {{product.ArticleNumber}} )</el-tag> 
                        </p>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('feedback.message')" prop="message" :required="true">
                            <el-input type="textarea" autofocus :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('feedback.message_placeholder')" v-model="newFeedback.Message"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :span="24">
                        <el-form-item :label="$t('feedback.star_rating')" >
                            <el-rate v-model="newFeedback.StarRating" :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :span="24">
                            <el-form-item>
                            <el-button type="primary" @click="save">{{$t('feedback.send_feedback')}}</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
        </el-form> 
      
    </div>
  </div>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from '@/views/BasePage';

export default {
  name: "products",
  extends: BasePage,
  data () {
    return { 
      tableLoadingVisible: false,
      errorFromServer:false,
      order: {},
      product: {},
      buyer: {},
      seller: {},
      buyer_factory: {},
      seller_factory: {},
      newFeedback: { Message: "", StarRating: 1 },
      rules: {}
    }
  },
  methods: {
    async refresh_info() 
    {
        var id_feedback      = this.$route.params.id;
        var response         = await this.post('feedback/refresh_info',  { id: id_feedback } );
        this.errorFromServer = response.Error;
        this.order           = response.Order;
        this.product         = response.Product;

        this.buyer              = response.Buyer;
        this.seller             = response.Seller;
        this.buyer_factory      = response.BuyerFactory;
        this.seller_factory     = response.SellerFactory;
    },
   
    async save(item){
        var id_feedback = this.$route.params.id;
        var response    = await this.post('feedback/save',  { id: id_feedback, feedback: this.newFeedback } );
        var error       = response.Error;
        if(!error)
        {
            this.$message({ message: 'Feedback sent with success!', type: 'success'});
        }
        else
        {
            this.$message({ message: 'Feedbak already completed or other error ocured!', type: 'error'});
        }
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>

</style>